<!--
* @description  参数1
* @fileName  billingDetails
* @author userName
* @date 2024-01-22 15:02:31
!-->
<template>
  <div id="billingDetails" class="billingDetails">
    <div v-if="!isEdit" class="edit-main">
      <div class="billingDetails-title">
        公司账单详情
      </div>
      <div class="main-info p24 check-price-form">
        <el-form
          ref="formData"
          :model="formData"
          :rules="allRules"
          label-position="top"
          size="medium"
          class="item-Surcharge"
          @submit.native.prevent
        >
          <div class="new_inquiry_header item-Surcharge_search">
            <el-form-item class="flex-width_1 mt17" prop="fullName" label="联系人姓名" label-width="48%">
              <el-input v-model="formData.fullName" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="companyName" label="公司名称" label-width="48%">
              <el-input v-model="formData.companyName" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="phone" label="电话" label-width="48%">
              <el-input v-model="formData.phone" />
            </el-form-item>
            <el-form-item
              class="flex-width_1"
              prop="businessType"
              label="开展业务(选填)"
              label-width="48%"
            >
              <el-input v-model="formData.businessType" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="vat" label="增值税/税号 (可选)" label-width="48%">
              <el-input v-model="formData.vat" />
            </el-form-item>
            <el-form-item
              class="flex-width_1"
              prop="address"
              label="公司账单地址"
              label-width="48%"
            >
              <el-input v-model="formData.address" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="city" label="城市" label-width="48%">
              <el-input v-model="formData.city" />
            </el-form-item>
            <el-form-item
              class="flex-width_1"
              prop="region"
              label="州/地区(选填)"
              label-width="48%"
            >
              <el-input v-model="formData.region" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="zipcode" label="邮政编码(选填)" label-width="48%">
              <el-input v-model="formData.zipcode" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="country" label="国家" label-width="48%">
              <el-input v-model="formData.country" />
            </el-form-item>
          </div>
        </el-form>
        <div class="foot-button">
          <button class="by-common--primary" @click="clickCancel">取消</button>
          <button class="by-button--primary" @click="clickSave">保存</button>
        </div>
      </div>
    </div>
    <div v-if="isEdit" class="details-main">
      <div class="company-billing-details">
        <div class="company-b-d-title">
          <div class="company-b-d-title-l">公司账单详情</div>
          <div class="company-b-d-title-r" @click="()=>{isEdit = false}">修改</div>
        </div>
        <div class="company-b-d-info">{{ formData.companyName }}</div>
        <div class="company-b-d-details">
          <p>VAT/Tax ID: {{ formData.vat }}</p>
          <p>{{ formData.fullName }}</p>
          <p>{{ formData.phone }}</p>
          <p>{{ formData.address }}</p>
        </div>
      </div>
      <div class="amount-due">
        <div class="amount-due-l">应付金额</div>
        <div class="amount-due-r">CNY{{ orderData.totalAmount }}</div>
      </div>

      <PaymentDetails v-if="isEdit" ref="PaymentDetails" @next="next" />

    </div>

  </div>
</template>

<script>
import {
  GetCompanyBilling,
  CreateCompanyBilling,
  UpdateCompanyBilling
} from '../../../../../../api/order.js'
import PaymentDetails from './paymentDetails.vue'
export default {
  name: 'BillingDetails',
  components: {
    // 组件的引用
    PaymentDetails
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      formData: {
        fullName: '',
        companyName: '',
        phone: '',
        businessType: '',
        vat: '',
        address: '',
        city: '',
        region: '',
        zipcode: '',
        country: ''
      },
      allRules: {
        fullName: [{
          required: true,
          message: 'Required'
        }],
        companyName: [{
          required: true,
          message: 'Required'
        }],
        phone: [{
          required: true,
          message: 'Required'
        }],
        address: [{
          required: true,
          message: 'Required'
        }],
        city: [{
          required: true,
          message: 'Required'
        }],
        country: [{
          required: true,
          message: 'Required'
        }]
      },
      isEdit: false,
      orderNo: '',
      orderData: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    next(stepName, index) {
      this.$emit('next', stepName, index)
    },
    init(data) {
      this.orderNo = data.orderNo
      this.orderData = data
      GetCompanyBilling(this.orderNo).then(res => {
        if (res.code === 200) {
          this.formData = res.data
          if (this.formData.companyName) {
            this.isEdit = true
            this.$nextTick(() => {
              this.$refs.PaymentDetails.init(this.orderData.orderNo)
            })
          }
        }
      })
    },
    // 方法
    clickSave() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          if (this.formData.orderNo === this.orderNo) {
            UpdateCompanyBilling(this.formData).then(res => {
              if (res.code === 200) {
                this.init(this.orderData)
                this.isEdit = true
                this.$nextTick(() => {
                  this.$refs.PaymentDetails.init(this.orderData.orderNo)
                })
              }
            })
          } else {
            this.formData.orderNo = this.orderNo
            CreateCompanyBilling(this.formData).then(res => {
              if (res.code === 200) {
                this.init(this.orderData)
                this.isEdit = true
                this.$nextTick(() => {
                  this.$refs.PaymentDetails.init(this.orderData.orderNo)
                })
              }
            })
          }
        }
      })
    },
    clickCancel() {}
  }
}
</script>
<style scoped lang='scss'>
	.mt17 {
		margin-top: 17px;
	}

	.billingDetails {

		.billingDetails-title {
			height: 56px;
			font-size: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			color: #333333;
			line-height: 56px;
			text-align: left;
			border-bottom: 1px solid #DDDDDD;
		}

		.new_inquiry_header {
			width: auto;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.el-form-item--medium:nth-of-type(1),
			.el-form-item--medium:nth-of-type(6) {
				width: 100%; //calc(99% - 28px);
				margin-right: 0px;
				padding-right: 0px;
			}
		}

	}

	.el-select {
		width: 100%;
	}

	::v-deep .el-form-item--medium {
		//margin-bottom: 48px !important;
		//margin-right: 24px;
		// max-width: 200px;
		// min-width: 200px;
		width: 49%;
		float: left;
		text-align: left;

		.el-form-item__label {
			line-height: 30px !important;
			margin-top: 0px !important;
		}

		// .el-input__inner {
		//   width: 200px;
		// }
		.input-Lowest {
			display: flex;

			.el-radio-group {
				width: 120px;
			}

			.el-input__inner {
				width: 60px;
				margin-left: 12px;
			}

			.el-input {
				width: 60px !important;
			}
		}

		.el-radio-group {
			display: flex;
			margin-top: 8px;

			//width: 200px;
			label:nth-of-type(1) {
				margin-right: 20px !important;
			}

			label:nth-of-type(3) {
				margin-left: 10px !important;
			}
		}

		.el-radio__input.is-checked .el-radio__inner {
			border-color: #0046b9;
			background: #0046b9;
		}

		.el-radio__input.is-checked+.el-radio__label {
			color: #0046b9;
		}

		.el-input {
			.el-input__inner {
				border-radius: 4px;
				border: 1px solid #dcdcdc;
				height: 32px;
				line-height: 32px;
				padding-left: 8px;
				font-size: 13px;
				font-family: "PingFangSC-Regular", "Microsoft YaHei", sans-serif;
				font-weight: 500;
				color: #333333;

				&:hover {
					border: 1px solid #999999;
				}

				&:focus {
					border: 1px solid #0046b9;
				}
			}
		}
	}

	.foot-button {
		font-size: 16px;
		margin-top: 33px;
		padding-bottom: 24px;

		button {
			width: 160px;
			height: 40px;
			margin-left: 24px;
		}
	}

	.font-style {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.flex-center-between {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	//编辑样式
	.billingDetails {
		.edit-main {
			width: 964px;
			height: auto;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 0 16px;
		}

		.details-main {
			.company-billing-details {
				width: 964px;
				height: 200px;
				background: #FFFFFF;
				border-radius: 8px;
				padding: 18px 16px;

				.company-b-d-title {
					@extend .flex-center-between;

					.company-b-d-title-l {
						@extend .font-style;
					}

					.company-b-d-title-r {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #EF0A0A;
					}
				}

				.company-b-d-info {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
					text-align: left;
					margin: 6px 0 12px 0;

				}

				.company-b-d-details {
					text-align: left;
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #777777;
				}
			}

			.amount-due {
				margin: 16px 0;
				width: 964px;
				height: 56px;
				background: #FFFFFF;
				border-radius: 8px;
				padding: 0 16px;
				@extend .flex-center-between;

				.amount-due-l {
					@extend .font-style;
				}

				.amount-due-r {
					font-size: 20px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #EF0A0A;
				}
			}
		}
	}
</style>
